<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-06-28 13:33:23
-->
<template>
  <div class="component__loading--progress">
    <div class="flex-row row__message">
      <i class="el-icon-loading flex__no-shrink"></i>
      <div
        class="flex-expend container__message"
        v-if="dangerouslyUseHTMLString"
        v-html="message"
      ></div>
      <div v-else class="flex-expend container__message">
        {{ message }}
      </div>
      <el-button
        v-if="cancelable"
        class="flex__no-shrink"
        :disabled="hasCanceled"
        type="danger"
        size="mini"
        @click="cancel"
        >{{ hasCanceled ? "取消中" : "取消" }}</el-button
      >
    </div>
    <div class="row row__progress" v-if="progressing">
      <el-progress
        stroke-linecap="butt"
        :percentage="progress"
        :stroke-width="16"
      ></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cancelable: {
      type: Boolean,
      default: false,
    },
    cancelAction: {
      type: Function,
      default: false,
    },
    dangerouslyUseHTMLString: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progressing: false,
      message: "",
      progress: 0,
      hasCanceled: false,
    };
  },
  methods: {
    cancel() {
      this.hasCanceled = true;
      this.cancelAction && this.cancelAction();
    },
  },
};
</script>

<style lang="scss">
.component__loading--progress {
  border: 2px;
  padding: 28px;
  background: white;
  display: flex;
  flex-direction: column;
  max-width: 360px;
  font-size: 14px;
  color: #5e6d82;

  .row {
    position: relative;
    white-space: nowrap;
    text-align: left;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-icon-loading {
    color: "#409eff";
    margin-right: 8px;
  }
  .el-progress-bar {
    margin-right: -55px;
    padding-right: 55px;
  }
  .el-progress__text {
    width: 55px;
    text-align: right;
    margin-left: 0;
  }
  .el-button {
    padding: 4px 8px !important;
  }
  .el-progress-bar__outer,
  .el-progress-bar__inner {
    border-radius: 2px !important;
  }

  .row__message {
    > i,
    > .container__message {
      line-height: 22px;
    }

    >i{
      height: 22px;
      align-self: center;
    }

    .container__message {
      text-align: left;
    }
  }

  .row__progress {
    margin-top: 6px;
  }
}
</style>